import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AuthLoadingScreen = (): React.JSX.Element => {
  const { authStatus, authError } = useAuth();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <div
          className="loading-spinner"
          style={{
            width: '50px',
            height: '50px',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #3498db',
            borderRadius: '50%',
            margin: '0 auto 20px auto',
          }}
        ></div>

        <h2>Loading</h2>
        <p className="text-muted" style={{ marginBottom: '10px' }}>
          {authStatus}
        </p>

        {authError && (
          <div
            style={{
              color: '#e74c3c',
              backgroundColor: '#fdf2f2',
              border: '1px solid #fecaca',
              padding: '10px',
              borderRadius: '5px',
              margin: '10px 0',
              maxWidth: '400px',
            }}
          >
            <strong>Error:</strong> {authError}
          </div>
        )}
      </div>

      <style>{`
        .loading-spinner {
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AuthLoadingScreen;
